import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState("patients"); // "patients", "operators", "all"
  const [loading, setLoading] = useState(true);

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  useEffect(() => {
    if (!user?.token) return;

    fetch(`${API_URL}/api/admin/users`, {
      headers: { Authorization: "Bearer " + user.token },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setUsers(data);
        else {
          console.error("Ожидался массив пользователей, получили:", data);
          setUsers([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Ошибка загрузки пользователей:", err);
        setUsers([]);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleHoldUser = (userId) => {
    setUsers((prev) =>
      prev.map((u) => (u._id === userId ? { ...u, role: "HOLD" } : u))
    );
    // Можно добавить API-запрос на сервер для пометки пользователя
  };

  const patientsWithNoCertificate = users.filter(
    (u) => u.role === "patient" && u.uploadedFiles?.length > 0 && !u.certificate
  );

  const patientsWithCertificate = users.filter(
    (u) => u.role === "patient" && u.certificate
  );

  const operators = users.filter((u) => u.role === "operator");

  const allUsers = users;

  const renderUsers = (list) => {
    if (list.length === 0) return <p>Пользователи не найдены</p>;

    return list.map((u) => (
      <div
        key={u._id}
        style={{
          border: "1px solid #ccc",
          margin: "10px",
          padding: "10px",
        }}
      >
        <p>
          {u.fullName} ({u.email}) - роль: {u.role}
        </p>
        {u.uploadedFiles && u.uploadedFiles.length > 0 && (
          <ul>
            {u.uploadedFiles.map((f, i) => (
              <li key={i}>
                <a href={f.url} target="_blank" rel="noreferrer">
                  {f.name}
                </a>
              </li>
            ))}
          </ul>
        )}
        {u.certificate && (
          <p>
            Справка:{" "}
            <a href={u.certificate.url} target="_blank" rel="noreferrer">
              {u.certificate.name}
            </a>
          </p>
        )}
        <button onClick={() => handleHoldUser(u._id)}>Пометить HOLD</button>
      </div>
    ));
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Админ-панель
      </h1>

      <div className="div__upper" style={{ marginBottom: "20px" }}>
        <button onClick={() => setActiveTab("patients")}>
          Пациенты ({patientsWithNoCertificate.length})
        </button>
        <button onClick={() => setActiveTab("operators")}>
          Операторы ({operators.length})
        </button>
        <button onClick={() => setActiveTab("all")}>Все пользователи</button>
      </div>

      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <>
          {activeTab === "patients" &&
            renderUsers([
              ...patientsWithNoCertificate,
              ...patientsWithCertificate,
            ])}
          {activeTab === "operators" && renderUsers(operators)}
          {activeTab === "all" && renderUsers(allUsers)}
        </>
      )}

      <button onClick={logout} className="btn btn--secondary">
        Выйти
      </button>
    </section>
  );
}
